import { Column } from 'components/atoms/grid';
import { dueDateRenderer } from './due-date-renderer';
import { DueDateValue, dueDateValueGetter } from './due-date-value-getter';

export const dueDateColumn = (column: Column): Column => {
  return {
    ...column,
    renderer: ({ value }: { value?: DueDateValue }) => dueDateRenderer(value),
    valueGetter: dueDateValueGetter,
    comparator: (a, b) => {
      const a_due_date = (a?.dueDate as string) ?? '';
      const b_due_date = (b?.dueDate as string) ?? -1;

      return a_due_date === b_due_date ? 0 : a_due_date < b_due_date ? -1 : 1;
    },
  };
};
